import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  IconButton,
  Modal,
  Paper,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
  TableHead
} from "@mui/material";
import {
  Circle as CircleIcon,
  Check as CheckIcon,
  Clear as ClearIcon
} from "@mui/icons-material";
import api from "../../../../helpers/api/ConnectedApi";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import "./checkConnection.css";

function CheckConnection() {
  const refreshRate = useSelector(state => state.refresh_rate);
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [connectColor, setConnectColor] = useState();
  const [timeUpdated, setTimeUpdated] = useState(new Date());
  const timeoutRef = useRef();

  useEffect(() => {
    checkConnected();
    return () => window.clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    setRefreshTime();
  }, [timeUpdated]);

  const setRefreshTime = () => {
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(
       () => {
         timeoutRef.current = null;
         setTimeUpdated(new Date());
         checkConnected();
       }, refreshRate * 1000
    );
  }

  const checkConnected = () => {
    api.get(ApiUrls.check_connection)
      .then((response) => {
        setResult(response.data.result);
      })
      .catch((error) => {});
  }

  const setResult = (result) => {
    let state = "success";
    let temp_rows = [];

    for (let i = 0; i < result.length; i++) {
      const res_i = result[i];
      let temp_r = res_i.result;

      let allKeys = Object.keys(temp_r);
      allKeys.sort();

      let result_cell = (
         <div>
           {allKeys.map((key, i) => {
             const r = temp_r[key];
             if (r == "0") {
               state = "error";
             }

             return (
                <div className="connected-data d-flex justify-content-between" key={i}>
                  <div>
                    {r == 1
                       ? <CheckIcon color="success" sx={{ fontSize: '25px' }} />
                       : <ClearIcon color="error" sx={{ fontSize: '25px' }} />
                    }
                  </div>
                  <div>
                    {key}
                  </div>
                </div>
             )
           })}
         </div>
      );

      temp_rows.push({
        name: res_i.name,
        ip: res_i.ip,
        result_cell
      });
    }

    setConnectColor(state);
    setRows(temp_rows);
  }

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {connectColor ?
        <IconButton
          color={connectColor}
          className="p-0 ms-3"
          aria-label="isConnected"
          onClick={handleOpen}
        >
          <CircleIcon />
        </IconButton>
        : null
      }

      {open ?
         <Modal
            open={open}
            onClose={handleClose}
            className="mui-modal-custom"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
           <TableContainer component={Paper} className="check-connected">
             <Table>
               <TableHead>
                 <TableRow>
                   <TableCell sx={{ width: '30%' }}>سایت</TableCell>
                   <TableCell align="center" sx={{ width: '30%' }}>IP</TableCell>
                   <TableCell align="center" sx={{ width: '40%' }}>وضعیت اتصال</TableCell>
                 </TableRow>
               </TableHead>

               <TableBody>
                 {rows.length > 0 && rows.map((row, index) => (
                    <TableRow
                       key={index}
                       sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="center">{row.ip}</TableCell>
                      <TableCell align="center" sx={{ paddingY: 1 }}>
                        {row.result_cell}
                      </TableCell>
                    </TableRow>
                 ))}
               </TableBody>
             </Table>
           </TableContainer>
         </Modal>
         :
         null
      }
    </>
  )
}

export default CheckConnection;